import { Grid, Typography } from "@mui/material";
import type { JSX } from "react";

type Props = {
  left: JSX.Element | string;
  right: JSX.Element | string;
};

export const BankAccountDetailRow = ({ left, right }: Props) => (
  <>
    <Grid size={{ xs: 2 }}>
      <Typography textAlign="left" alignSelf="center">
        {left}
      </Typography>
    </Grid>
    <Grid size={{ xs: 10 }}>
      <Typography
        fontSize={15}
        fontWeight={500}
        textAlign="right"
        sx={{ wordBreak: "break-all" }}
        component="div"
      >
        {right}
      </Typography>
    </Grid>
  </>
);
